// extracted by mini-css-extract-plugin
export default {"frame":"CardPreview_frame__hopcz","canvas":"CardPreview_canvas__jqjG6","picture":"CardPreview_picture__fKB2n"};